import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, Rectangle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../components/eventmap.css';

// Fix Leaflet marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// ✅ Component to zoom into the bounding box
function ZoomToBounds({ bounds }) {
  const map = useMap();

  useEffect(() => {
    if (bounds) {
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  }, [bounds, map]);

  return null;
}

export default function EventMap({ events, bounds, keywords }) {
  return (
    <div className="map-wrapper" style={{ height: '100%', width: '100%' }}>
      <MapContainer
        center={[39.8283, -98.5795]} // USA center fallback
        zoom={5}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {bounds && (
          <>
            <Rectangle bounds={bounds} pathOptions={{ color: 'blue', weight: 2 }} />
            <ZoomToBounds bounds={bounds} />
          </>
        )}

            {events
            .filter((event) => {
                if (!event.event_lat || !event.event_lon) return false;

                if (keywords) {
                const keywordList = keywords.toLowerCase().split(',').map(k => k.trim());
                const haystack = `${event.event_name ?? ''} ${event.description ?? ''}`.toLowerCase();
                return keywordList.some(k => haystack.includes(k));
                }

                return true;
            })
            .map((event) => (
                <Marker key={event.id} position={[event.event_lat, event.event_lon]}>
                <Popup>
                    <strong>{event.event_name}</strong><br />
                    {event.event_location}
                </Popup>
                </Marker>
            ))}

      </MapContainer>
    </div>
  );
}
